var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderStorage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6932d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7 4.667c2.9 0 5.25-.784 5.25-1.75 0-.967-2.35-1.75-5.25-1.75s-5.25.783-5.25 1.75c0 .966 2.35 1.75 5.25 1.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6932d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.25 7c0 .968-2.333 1.75-5.25 1.75S1.75 7.968 1.75 7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6932d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.75 2.917v8.166c0 .969 2.333 1.75 5.25 1.75s5.25-.781 5.25-1.75V2.917"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderStorage);
export default __webpack_public_path__ + "static/media/header-storage.613c91f2f566d0e3b3e44edeab50381c.svg";
export { ForwardRef as ReactComponent };